// removed by extract-text-webpack-plugin
module.exports = {"grid-header":"_3Nixc-RiP _2l0xl0HVf _17qxy1jyE fRuvB2aOu _2ltOFCwED _1OqJ1vEYi yJ3aJSEV8 _3QfjnbU8u","title":"_3EfirN4QM _1yJuXbiru _1FTxuUfut _13qojEuKg _3-7RXEMuO _3kvYUMIJc _1C-lRJLgc hxreTUKKY _32-zqX40L","actions":"Lj54iVaOR _1K-PUKdV4 _17qxy1jyE","save-button":"_3hZalQtL7 _17qxy1jyE _2r1vMEdE0"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid-header/grid-header.css
 ** module id = 2120
 ** module chunks = 0
 **/